import "../styles/about.css";
import user from "../images/sun.png";
import { FaEdit, FaUserCircle } from "react-icons/fa";
import sun from "../images/carrot.png";
import { useState, useEffect } from "react";
import api from "./api";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { Link } from "react-router-dom";

const About = () => {
    const [profile, setProfile] = useState(null);
    const [username, setUsername] = useState("");
    const [birthDate, setBirthDate] = useState("");
    const [profileImage, setProfileImage] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);

    // پسورد
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    useEffect(() => {
        fetchProfile();
    }, []);

    const fetchProfile = () => {
        api.get("student/api/v1/show-student-profile/")
            .then((res) => {
                setProfile(res.data);
                setUsername(res.data.username || "");
                setBirthDate(res.data.birth_date || "");
            })
            .catch((err) => {
                console.error("خطا در گرفتن اطلاعات پروفایل:", err);
            });
    };

    // انتخاب فایل و پیش‌نمایش
    const handleFileSelect = (file) => {
        if (!file) return;
        if (file.size > 2 * 1024 * 1024) {
            alert("حجم تصویر نباید بیشتر از ۲ مگابایت باشد");
            return;
        }
        setProfileImage(file);
        setPreviewImage(URL.createObjectURL(file)); // پیش نمایش
    };

    const handleUploadImage = async () => {
        if (!profileImage) {
            alert("لطفا یک تصویر انتخاب کنید");
            return;
        }

        try {
            const formData = new FormData();
            formData.append("profile_image", profileImage);

            const res = await api.patch(
                "student/api/v1/update-profile-image/",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );



            // استفاده از پیش‌نمایش فوری با تصویر انتخاب شده
            setPreviewImage(URL.createObjectURL(profileImage));

            // پاک کردن فایل انتخاب شده بعد از آپلود
            setProfileImage(null);

            alert("تصویر با موفقیت بروزرسانی شد");

            // بعداً fetchProfile برای اطمینان از مسیر نهایی سرور
            fetchProfile();
        } catch (err) {
            console.error("Upload error:", err.response || err);
            alert("خطا در بروزرسانی تصویر");
        }
    };


    // ویرایش یوزرنیم و تاریخ تولد
    const handleUpdateProfile = () => {
        const data = {};
        if (username !== profile.username) data.username = username;
        if (birthDate !== profile.birth_date) data.birth_date = birthDate;

        if (Object.keys(data).length === 0) {
            alert("تغییری ایجاد نشده است.");
            return;
        }

        api.put("student/api/v1/update-student-profile/", data)
            .then(() => {
                alert("اطلاعات با موفقیت بروزرسانی شد");
                fetchProfile();


            })
            .catch(() => alert("خطا در بروزرسانی اطلاعات"));
    };

    // تغییر پسورد
    const handleChangePassword = () => {
        if (newPassword !== confirmPassword) {
            alert("پسورد جدید و تکرار آن برابر نیستند");
            return;
        }

        api.put("student/api/v1/change-password/", {
            old_password: oldPassword,
            new_password: newPassword,
            confirm_new_password: confirmPassword,
        })
            .then(() => {
                alert("رمز عبور با موفقیت تغییر کرد");
                setOldPassword("");
                setNewPassword("");
                setConfirmPassword("");
            })
            .catch(() => alert("خطا در تغییر رمز عبور"));
    };

    if (!profile) return <div></div>;

    return (
        <div className="me-lg-5 mb-2 pe-lg-5"  >
           

            <div className="row p-0">
                
                <div className="col-lg-4 d-flex d-lg-block justify-content-center col-12 p-0">
                    <div >
                        <div className="my-3">
                            <span className="fw-bold ms-3"> اطلاعات شخصی</span>
                            <img src={sun} width={33} height={33} />
                        </div>
                        <div className="student-box  p-5" style={{ width: "350px" }}>
                            <div>
                                <div className="edit-icon">
                                    <FaEdit style={{ fontSize: "20px" }} />
                                </div>
                                <div className="d-flex justify-content-center">
                                    <div>
                                        <div>
                                            <div className="d-flex justify-content-center">
                                                {previewImage || profile.profile_image ? (
                                                    <img
                                                        className="rounded-circle"
                                                        src={previewImage || `${profile.profile_image}`}

                                                        width={105}
                                                        height={105}
                                                    />
                                                ) : (
                                                    <FaUserCircle size={105} />
                                                )}
                                            </div>

                                            <input
                                                type="file"
                                                className="d-none"
                                                id="uploadInput"
                                                onChange={(e) =>
                                                    handleFileSelect(e.target.files[0])
                                                }
                                            />
                                            <label
                                                htmlFor="uploadInput"
                                                className="d-block upload-btn my-3 text-center"
                                                style={{ cursor: "pointer" }}
                                            >
                                                آپلود عکس جدید
                                            </label>
                                            <span
                                                className="d-flex justify-content-center"
                                                style={{
                                                    color: "rgba(97, 97, 97, 1)",
                                                    fontSize: "12px",
                                                }}
                                            >
                                                حداکثر حجم : ۲MB
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="">
                                    <div>
                                        <div>
                                            <label>نام</label>
                                            <div className="about-input d-block">
                                                {profile.first_name}
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            <label> نام خانوادگی</label>
                                            <div className="d-block about-input">
                                                {profile.last_name}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-center">
                                        <button
                                            className="upload-btn py-2 mt-3 px-5"
                                            onClick={handleUploadImage}
                                        >
                                            تایید
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>


                <div className="col-lg-4 d-flex d-lg-block justify-content-center col-12 p-0" >
                    <div>
                        <div >
                            <div className=" my-3">
                                <span className="fw-bold "> اطلاعات تکمیلی</span>
                                <img src={sun} width={33} height={33} />
                            </div>
                        </div>



                        <div className="student-box p-5" style={{ width: "350px" }}>
                            <div className="edit-icon">
                                <FaEdit style={{ fontSize: "20px" }} />
                            </div>
                            <div style={{ marginTop: "110px" }}>
                                <div>
                                    <label>نام کاربری</label>
                                    <input
                                        className="about-input d-block"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div>
                                <div>
                                    <label>  تلفن همراه </label>
                                    <div className="d-block about-input">
                                        {profile.phone_number}
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <label>تاریخ تولد</label>

                                    <DatePicker
                                        calendar={persian}
                                        locale={persian_fa}
                                        className="d-block about-input"
                                        value={birthDate}
                                        onChange={(date) => setBirthDate(date?.format("YYYY-MM-DD"))}
                                        style={{
                                            width: "100%",
                                            padding: "20px 30px",
                                            borderRadius: "8px",
                                            border: "1px solid #ccc", marginTop: "10px"
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="d-flex justify-content-center">
                                <button
                                    className="upload-btn py-2 mt-3 px-5"
                                    onClick={handleUpdateProfile}
                                >
                                    تایید
                                </button>
                            </div>
                        </div>

                    </div>

                </div>




                {/* باکس سوم - تغییر پسورد */}
                <div className="col-lg-4 d-flex d-lg-block justify-content-center col-12 p-0">
                    <div>
                        <div className="col-12 col-lg-4">
                            <div className=" my-3">
                                <span className="fw-bold ms-3"> کلمه عبور</span>
                                <img src={sun} width={33} height={33} />
                            </div>
                        </div>
                        <div className="student-box p-5" style={{ width: "350px" }}>
                            <div className="edit-icon">
                                <FaEdit style={{ fontSize: "20px" }} />
                            </div>
                            <div style={{ marginTop: "100px" }}>
                                <div>
                                    <label> کلمه عبور فعلی</label>
                                    <input
                                        type="password"
                                        className="about-input d-block"
                                        value={oldPassword}
                                        onChange={(e) => setOldPassword(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div>
                                <div>
                                    <label>کلمه عبور جدید </label>
                                    <input
                                        type="password"
                                        className="about-input d-block"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div>
                                <div>
                                    <label>تکرار کلمه عبور جدید</label>
                                    <input
                                        type="password"
                                        className="about-input d-block"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="d-flex justify-content-center">
                                <button
                                    className="upload-btn py-2 mt-3 px-5"
                                    onClick={handleChangePassword}
                                >
                                    تایید
                                </button>
                            </div>
                        </div>
                    </div>

                </div>


            </div>
        </div>
    );
};

export default About;
